import $ from "jquery";

import './materials/sections/gallery';

import {handlerGallerySwipe} from "./materials/sections/gallery/swipe-handler";
import {eternalScrollOnReadyHandlers, scrollGetNextHandler} from './materials/common/eternalScrollOnReadyHandlers';
import {eventAds} from "./materials/common/ads";
import {scrollToComments} from "./materials/common/scroll-to-comments";
import {partnersWidgetHeight} from "./materials/partners-widget/partners-widget-height";
import {lazyLoad} from "./materials/embeds/lazy-load";
import {handleSocialSection} from "./materials/common/section-social-handler";
import {scrollHandlers} from "./common/scroll-handlers";
import {clickTestButton} from "./materials/sections/tests/test-page";
import {showTestResult} from "./materials/sections/tests/show-test-result";
import {MaterialContentRecommendHandlers} from "./materials/sections/material-content-recommend";
import {partnerWidgetGeneralHandlers} from "./materials/partners-widget/partner-widget-general-handlers";

$(() => {
    eternalScrollOnReadyHandlers();
    handleSocialSection();
    handlerGallerySwipe();

    eventAds();
    scrollToComments();
    partnersWidgetHeight();
    lazyLoad();
    clickTestButton();
    showTestResult();
    MaterialContentRecommendHandlers();
    partnerWidgetGeneralHandlers();

    $(window).on("resize", function () {
        partnersWidgetHeight();
    });

    $(window).on("scroll", function () {
        scrollGetNextHandler();
        scrollHandlers();
    });
});
